<template>
  <div class="row">
    <div class="col-lg-8">
      <h2 class="inline">Requirement Report</h2>
    </div>
    <div class="col-lg-4 style-date">
      <span class="demonstration">Select Date Range</span>
      <el-date-picker
        v-model="value2"
        type="daterange"
        range-separator="To"
        start-placeholder="Start date"
        end-placeholder="End date"
        @change="getDate()"
      ></el-date-picker>
    </div>
    <div class="col-lg-4 style-select">
      <h4>
        Select Site:
        <el-select
          class="select-primary tab"
          placeholder="Single Select"
          v-model="selects.simple_site"
          @change="getData()"
        >
          <el-option
            v-for="option in selects.site"
            class="select-primary"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </el-select>
      </h4>
    </div>
    <div class="col-lg-4 style-select">
      <h4>
        Select Department:
        <el-select
          class="select-primary tab"
          placeholder="Single Select"
          v-model="selects.simple_department"
          :disabled="disableDept"
          @change="getDepartment()"
        >
          <el-option
            v-for="option in selects.department"
            class="select-primary"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </el-select>
      </h4>
    </div>
    <div class="col-lg-4 style-select">
      <h4>
        Select Vehicle Category:
        <el-select
          class="select-primary tab"
          placeholder="Single Select"
          v-model="selects.simple_vehicleType"
          :disabled="disableCat"
          @change="getVehCat()"
        >
          <el-option
            v-for="option in selects.vehicleType"
            class="select-primary"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </el-select>
      </h4>
    </div>

    <div class="col-lg-12">
      <hr />
    </div>
    <div class="col-md-12">
      <card card-body-classes="table-full-width">
        <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <base-input label="rows visible">
          <el-select
            class="select-info mb-3 pagination-select"
            v-model="pagination.perPage"
            placeholder="Per page"
          >
            <el-option
              class="select-primary"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          </base-input>
          <base-input>
            <el-input
              type="search"
              class="mb-3 search-input"
              clearable
              prefix-icon="el-icon-search"
              placeholder="Search records"
              v-model="searchQuery"
              aria-controls="datatables"
            ></el-input>
          </base-input>
        </div>
        <el-table :data="queriedData"  :header-cell-style="{
              background: 'transparent',
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
            :cell-style="{
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }">
          <el-table-column
            min-width="90"
            sortable
            align="center"
            label="Date"
            property="date"
          ></el-table-column>
          <el-table-column min-width="100" sortable align="center" label="Site" property="site"></el-table-column>
          <el-table-column
            min-width="90"
            sortable
            align="center"
            label="Department"
            property="department"
          ></el-table-column>
          <el-table-column
            min-width="110"
            sortable
            align="center"
            label="Vehicle Category"
            property="vehicleType"
          ></el-table-column>
          <el-table-column
            min-width="110"
            sortable
            align="center"
            label="Total"
            property="total"
          ></el-table-column>
          <!-- <el-table-column
            min-width="100"
            sortable
            align="center"
            label="Manufacture"
            property="manufacture"
          ></el-table-column>
          <el-table-column
            min-width="100"
            sortable
            align="center"
            label="Vehicle No"
            property="vehicleNo"
          ></el-table-column>
          <el-table-column
            min-width="140"
            sortable
            align="center"
            label="Preventive Maintenace"
            property="preventiveMaintenace"
          ></el-table-column>
          <el-table-column
            min-width="100"
            sortable
            align="center"
            label="Odometer"
            property="odometer"
          ></el-table-column>
          <el-table-column min-width="100" sortable align="center" label="Status" property="status"></el-table-column> -->
        </el-table>
        <div class="d-flex justify-content-center spinner" v-if="load">
          <circle-8></circle-8>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>
          </div>
          <base-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></base-pagination>
        </div>
      </card>
    </div>
    <div class="col-lg-12 text-right">
      <base-button type="primary" @click="exportCSV(tableData)">Export to CSV</base-button>
    </div>
  </div>
</template>
<script>
import config from "@/config";
import { Table, TableColumn } from "element-ui";
import { Select, Option, DatePicker } from "element-ui";
import moment from "moment";
import { BasePagination } from "src/components";
import Fuse from "fuse.js";
import { Circle8 } from "vue-loading-spinner";
import swal from 'sweetalert2';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    Circle8
  },
  data() {
    return {
      load: false,
      // Selecting interval data
      selects: {
        simple_department: "",
        simple_site: "",
        simple_vehicleType: "",
        site: [],
        department: [],
        vehicleType: []
      },
      value2: "",
      tableData: [],
      ttlRequirement: [],
      disableDept: true,
      disableCat: true,
      hold: [],
      hold2: [],
      searchQuery: "",
      propsToSearch: ["site", "department", "vehicleType"],
      // tableData: [],
      searchedData: [],
      fuseSearch: null,
      currentRow: "",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      // date
      startdate: "",
      enddate: ""
    };
  },
  created(){
    this.startdate = moment().startOf('isoWeek').unix()
    this.enddate = moment().endOf('isoWeek').unix()
    this.getReplacement()
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      console.log(this.searchedData)
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      console.log(result)
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  methods:{
    getReplacement(){
      this.load = true
      this.$http.get(":9993/api/v1/report/requirement/" + this.startdate + "/" + this.enddate)
        .then(res=>{
          if (!res.error){
            let response = res.message
            console.log(response)
            // total data

            for(var i=0;i<response.length; i++){
              let data = {
                id : i,
                site : response[i].SiteName,
                department : response[i].DeptName,
                vehicleType : response[i].CategoryName,
                total : response[i].RequirementNo,
                date : moment(response[i].Date).format("YYYY-MM-DD")
                // manufacture : response[i].VecManuf,
                // vehicleNo : response[i].Vehicle,
                // preventiveMaintenace : response[i].VehPMDate,
                // odometer : response[i].VehOdometer,
                // status : response[i].StatusName
              }

              this.tableData.push(data)
              this.ttlRequirement.push(data)
            }

            // filter
            
            let all = {
              label: "All",
              value: "All"
            }
            this.selects.site.push(all)
            this.selects.department.push(all)
            this.selects.vehicleType.push(all)

            // site filter
            let tempSite = []
            for(var i=0;i<response.length;i++){
              let data = response[i].SiteName

              if(tempSite.indexOf(data)=== -1){
                tempSite.push(data)
              }
            }

            console.log(tempSite)
            
            for(var i=0; i<tempSite.length; i++){
              let data = {
                label : tempSite[i],
                value : tempSite[i]
              }
              this.selects.site.push(data)
            }

            this.load = false
            // vehicle type filter
            // let tempVehType = []
            // for(var i=0;i<response.length;i++){
            //   let data = response[i].VehCatName

            //   if(tempVehType.indexOf(data)=== -1){
            //     tempVehType.push(data)
            //   }
            // }

            // console.log(tempVehType)
            
            // for(var i=0; i<tempVehType.length; i++){
            //   let data = {
            //     label : tempVehType[i],
            //     value : tempVehType[i]
            //   }
            //   this.selects.vehicleType.push(data)
            // }
          } else {
            swal({
              title: "Opps! something went wrong",
              text: res.message,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false
            });
            this.load =  false
          }
        })
    },
    getData(){
      this.load = true
      let temp = []
      this.searchQuery = ""
      this.selects.department = []
      this.selects.vehicleType = []
      this.selects.simple_department = ""
      this.selects.simple_vehicleType = ""
      this.tableData = this.ttlRequirement
      this.searchedData = []
      if (this.selects.simple_site != "All"){
        for(var i=0; i<this.tableData.length; i++){
          if(this.selects.simple_site == this.tableData[i].site){
            temp.push(this.tableData[i])
          }
          console.log(temp)
        }
        this.tableData = temp
        this.searchedData = temp
      } else {
        this.tableData = this.ttlRequirement
        this.searchedData = this.ttlRequirement
      }
      this.hold = this.tableData
      this.disableDept = false

      // department filter
      let all = {
        value: "All",
        label: "All"
      }
      this.selects.department.push(all)
      let tempDepartment = []
      for(var i=0;i<this.tableData.length;i++){
        let data = this.tableData[i].department
        if(tempDepartment.indexOf(data)=== -1){
          tempDepartment.push(data)
        }
      }

      console.log(tempDepartment)
            
      for(var i=0; i<tempDepartment.length; i++){
        let data = {
          label : tempDepartment[i],
          value : tempDepartment[i]
        }
        this.selects.department.push(data)
      }
      this.load = false
    },
    getDepartment(){
      this.load = true
      this.searchQuery = ""
      console.log(this.hold)
      console.log(this.tableData)
      console.log(this.selects.simple_department)
      let temp = []
      this.selects.vehicleType = []
      this.selects.simple_vehicleType = ""
      
      if(this.selects.simple_department != "All"){
        this.tableData = this.hold
        for(var i=0; i<this.tableData.length; i++){
          if(this.selects.simple_department == this.tableData[i].department){
            temp.push(this.tableData[i])
          }
        }
        this.tableData = temp
        this.searchedData = temp
      } else {
        this.tableData = this.hold
        this.searchedData = this.hold
        console.log(this.tableData)
      }

      // push category
      let tempCat = []
      for(var i=0; i<this.hold.length; i++){
        let cat = this.hold[i].vehicleType
        if(tempCat.indexOf(cat)=== -1){
          tempCat.push(this.hold[i].vehicleType)
        }
      }

      console.log(tempCat)

      for(var i=0; i<tempCat.length; i++){
        let data = {
          label : tempCat[i],
          value : tempCat[i]
        }
        this.selects.vehicleType.push(data)
      }

      this.hold2 = this.tableData
      this.disableCat = false
      this.load = false
    },
    getVehCat(){
      this.load = true
      console.log(this.hold2)
      console.log(this.tableData)
      console.log(this.selects.simple_vehicleType)
      let temp = []
      this.searchQuery = ""
      
      if(this.selects.simple_vehicleType != "All"){
        this.tableData = this.hold2
        for(var i=0; i<this.tableData.length; i++){
          if(this.selects.simple_vehicleType == this.tableData[i].vehicleType){
            temp.push(this.tableData[i])
          }
        }
        this.tableData = temp
        this.searchedData = temp
      } else {
        this.tableData = this.hold2
        this.searchedData = this.hold2
        console.log(this.tableData)
      }
      this.load = false
    },
    getDate(){
      this.load = true
      this.selects.department = []
      this.selects.site = []
      this.selects.vehicleType = []
      this.selects.simple_site = ""
      this.selects.simple_department = ""
      this.selects.simple_vehicleType = ""
      
      console.log(this.value2)
      this.startdate = moment(this.value2[0]).unix();
      this.enddate = moment(this.value2[1]).unix();

      // end = moment(this.value2[1])
      //   .add(23, "hours")
      //   .add(59, "minutes")
      //   .add(59, "seconds")
      //   .unix();

      console.log("start:", this.startdate)
      console.log("end:", this.enddate)
      this.tableData = []
      this.ttlRequirement = []
      this.searchedData = []
      this.getReplacement();
    },
    exportCSV(requirement){
      console.log(requirement)
      let csvData = this.$CSV(this.tableData);
      const blob = new Blob([csvData], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.setAttribute("hidden", "");
      a.setAttribute("href", url);
      a.setAttribute("download", "requirementReport.csv");
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {

      this.fuseSearch = new Fuse(this.tableData, {
        keys: ["vehicleType","department", "site"],
        threshold: 0.6
      });
     
      console.log("CURR_TABLEDATA", this.tableData)
      let result = this.tableData;
      console.log(result)
      // console.log(this.searchQuery)
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery) ;
      
      }
      console.log("DATA_RESULT:",result)
      this.searchedData = result;
      console.log("DATA_SEARCH:",this.searchedData)
      
    }
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["site", "department", "vehicleType"],
      threshold: 0.3
    });
  },
};
</script>
<style lang="scss">
.inline {
  margin-top: 1.5%;
  margin-bottom: 1%;
}
hr {
  color: black;
  margin-top: 0%;
}
.style-date {
  margin-bottom: 1%;
}
.style-select {
  padding-top: 1%;
}
</style>